// 该文件为自动生成，请不要直接修改该文件(直接修改该文件,送翻后修改会失效)
/* eslint-disable */
export default {
  "3259583117": "通知客戶端跳轉",
  "1d484fee4a": "財務部，銷售部，項目管理，業務數據，產品部，運營部，研發管理，版本計劃，客服部，行政部，採購部，售後管理",
  "a2c88dfb79": "創建您的第一個團隊",
  "3cfdcc6086": "財務部，銷售部，項目管理/305，人事行政/306，運營部，研發管理，版本計劃，客服管理/403，採購部，售後管理",
  "ac45ec2c05": "賬號登錄校驗失敗",
  "9aef9b8ccd": "當前登錄的賬號異常，請重新登錄賬號後嘗試",
  "728dd00f22": "該手機號校驗異常，請嘗試使用短信驗證碼登錄",
  "30dbecd916": "您的填寫信息中包含敏感詞，請修改後重試",
  "12ed508d8a": "您的操作過於頻繁，請稍後再試",
  "952d4a7595": "當前賬號的登錄狀態異常，請重新登錄賬號後嘗試",
  "e64bfdeaa4": "登錄校驗失敗，請重新獲取短信驗證",
  "79008a65f1": "該手機號已加入多個企業，請登錄企業或更換手機號",
  "bf242eff42": "企業名稱已存在",
  "4f0cdb8374": "請輸入完整手機號碼，若您使用海外手機號，請更換為國內號碼 (86+)",
  "46e79ffeff": "創建企業異常，請聯繫官方客服解決",
  "f3e18f0341": "參數驗證失敗",
  "503fd1718d": "發送短信驗證碼失敗",
  "24b3129f19": "短信發送太頻繁，請稍後再試",
  "1cde3e8245": "驗證碼有誤，請重新輸入",
  "4212ecc031": "已多次驗證錯誤，暫時限制驗證，請稍後再試",
  "735da9c347": "企業重名校驗異常，請聯繫官方客服解決",
  "8731da9615": "企業名認證校驗異常，請聯繫官方客服解決",
  "62e89b3f16": "同意服務協議",
  "c9b79027e5": "發送驗證碼",
  "84c1447b9d": "複製成功",
  "fba4b0abd0": "主機記錄",
  "37f5a7cd41": "TXT值",
  "78b12427c9": "認證中...",
  "59d089837c": "我們目前無法驗證您的域名，您可能需要再等候一段時間，以便域名托管服務商更新您的資訊。如果一段時間過後仍沒有反應，請嘗試再次驗證，或者更換域名。",
  "4a5b7383d1": "正在檢查域名",
  "f24a492e40": "的驗證記錄，您可以關閉本頁面，稍後再回來查看。",
  "c697ca5f1a": "歡迎使用企業版",
  "ebb01b1740": "下一步",
  "30109bf753": "您的企業有域名嗎？",
  "2b3e485b47": "我有企業域名",
  "1a7f5eae44": "我沒有企業域名",
  "bde15d6d84": "您需要有域名（例如example.com），才能為您創建企業帳號",
  "07ffb22c90": "抱歉，您需要有域名才能為您的企業創建企業帳號",
  "de23836563": "請輸入用於創建企業帳號的域名",
  "287c07944a": "驗證您的域名",
  "3ea2d528d5": "完成以下步驟即可證明您是 <b>{domain}</b> 的所有者，並禁止任何其他人使用這一域名註冊企業帳號。",
  "082b18ce56": "a. 在<b>新標籤頁</b>中打開域名托管服務商的網站，然後<b>登錄</b>您的帳號；",
  "4f7e0841a9": "b. 在域名托管服務商網站，轉到<b>DNS記錄部分</b>。在您的域名托管服務商網頁上，DNS記錄部分的名稱可能會有所不同，例如顯示為<b>DNS Management（DNS管理）、Name Sever Management（域名伺服器管理）、Control Panel（控制台）或Advanced Setting（高級設定）。</b>",
  "6365ad6e3a": "接下來，<b>返回此處</b>，然後點擊「下一步」以添加驗證記錄。",
  "8528892080": "添加驗證記錄",
  "7a225304f8": "a. 在DNS頁面，滾動到<b>TXT</b>部分，然後點擊相關按鈕以添加記錄；",
  "b3cb7d947c": "b. 將下方的所有值<b>複製並貼上</b>到域名托管服務商網站的<b>TXT表單</b>中；",
  "47213583bf": "c. <b>保留</b>域名托管服務商網站上的記錄，<br>然後<b>返回此處</b>，並點擊下方的「認證域名」",
  "21486a57cf": "注意：在名稱/主機/別名欄位，您可以輸入“@”或將其留空。域名托管服務商可能還會要求您在此欄位中輸入域名（<您的域名>.com）。您或許可以根據其他 DNS 記錄來判斷如何填寫此欄位。在存留時間 (TTL) 欄位中，輸入“86400”或保留預設值。",
  "f1b8edab9c": "更換域名",
  "7c6fc663a8": "認證域名",
  "b6aee9dc0d": "域名驗證成功",
  "dd4cc429ea": "已證明您是",
  "450f5c9230": "的所有者，並禁止任何其他人使用這一域名註冊企業帳號。",
  "71cbcba755": "點擊「下一步」去完成企業帳號創建吧。",
  "f4084f4870": "請設置您的登錄帳號",
  "fe3138baec": "完成創建",
  "0315cddedb": "企業創建成功",
  "91454a7f34": "現在去登錄管理後台為您的企業成員創建企業帳號吧",
  "366304cde7": "1. 將自動退出當前登錄的WPS帳號",
  "8a9f2a8422": "2. 您需使用企業帳號{account}@{domain}登錄管理後台",
  "43e265e998": "去登錄管理後台",
  "9240efaaf0": "短信已發送",
  "e424bb9a6d": "請輸入",
  "d44d581706": "企業名稱",
  "aa8679f406": "，4~30位",
  "581bdb1f98": "，不能包含特殊符號\\/:*?\"<>|{}",
  "c13cabb67a": "郵箱",
  "2b9b429e46": "您的郵箱",
  "5ed834a7df": "請輸入您的郵箱",
  "acfd1f02ed": "請輸入正確的郵箱",
  "31c7c92cca": "，最長80位",
  "3f27cf84b3": "請輸入驗證碼",
  "a0ae1f3ec4": "驗證碼不正確",
  "e5589c5e74": "您的姓名",
  "69d7bd63f6": "，僅限輸入漢字、字母、數字",
  "91f008d258": "，最長8位",
  "6ea6c9b39b": "聯繫電話",
  "161042c5b7": "請輸入聯繫電話",
  "e6b8eab1cd": "請輸入聯繫電話，11位數字",
  "3fd5fbb3cc": "請輸入您的域名",
  "cb5346ba8e": "請輸入正確的企業域名，4~30位",
  "27928eb7a4": "帳號",
  "8e19bd444d": "請輸入用於登錄的帳號名",
  "7bbbf479dc": "4-20位，僅數字、字母或下劃線",
  "3d84cae479": "請輸入符合要求的帳號/首字符需要為字母或數字",
  "c0d5ece1a7": "密碼",
  "f444036fa8": "請輸入密碼",
  "b03218d72b": "密碼為12-16位大小寫字母，數字或符合3種組合",
  "b4ab05df50": "*貴單位中已經有人將您的域名用於企業帳號，請聯繫客服（400-677-5005）證明您擁有此域名的所有權",
  "c58876008f": "複製失敗，請重試",
  "86f73420de": "邀請鏈接",
  "a58861962c": "對不起，您當前的瀏覽器不支持下載該二維碼",
  "228db07f78": "財務部，銷售部，項目管理，業務數據，產品部，運營部，研發管理，版本計劃，客服部，行政部，採購部，售後管理",
  "93896d7e98": "創建團隊後，與同事開始協作",
  "e8f66fb75c": "財務部，銷售部，項目管理/305，人事行政/306，運營部，研發管理，版本計劃，客服管理/403，採購部，售後管理",
  "831b73da9b": "名字不能包含非法字符和特殊符號/\\;:*?\"<>|%&",
  "51ab33b3ee": "參數不正確",
  "a297f9e951": "企業名稱重複",
  "04d60ed5f5": "不能使用違禁詞",
  "2ff7bef083": "域名格式錯誤",
  "41e1ba2165": "校驗域名TXT信息失敗",
  "50f348caa9": "帳號重複",
  "9d4c950d65": "該名稱已被註冊使用",
  "38cf19ed95": "該機構名稱已存在",
  "4b426e7c9c": "機構名",
  "298f880e18": "已存在，建議您補充更多信息：",
  "1e67dd20b3": "找回機構名稱",
  "517107cb04": "使用其他名稱",
  "5667081882": "使用該名稱創建",
  "e306a979a6": "快速填入：",
  "f583db96e0": "*若機構名被佔用，您可以",
  "9767148e34": "請輸入企業或者組織名稱，4~100字",
  "e0e0ec159f": "機構名稱",
  "5b13d254c0": "該企業名稱已存在",
  "92027671ec": "企業名",
  "36d482a7fb": "找回企業名稱",
  "79058a7577": "*若公司名被佔用，您可以",
  "c96dd48dba": "企業名稱",
  "842efad336": "*若您是企業員工，請",
  "860f9bd77b": "聯繫客服",
  "5a7ed18daf": "加入企業",
  "ab470e9ace": "預留聯繫信息",
  "0a7e0e48a7": "申請加入的企業名稱：",
  "a8dc318dcc": "請核對您填寫的聯繫信息，稍後平台客服會致電您",
  "6ea1f4d7f5": "提交資料",
  "d439e39f43": "已收到您的資料",
  "884653426b": "客服將在24小時內致電您，請注意接聽！",
  "2361cb14bf": "微信掃碼添加在線客服，了解進度",
  "50f45d0031": "保存失敗",
  "fc856d0fd2": "超級管理員",
  "e16c0676d2": "管理員",
  "b1d2ddd126": "普通成員",
  "9d322cc08d": "機構名稱不能包含特殊符號\\/:*?\"<>|{}",
  "b583ba7363": "企業名稱不能包含特殊符號\\/:*?\"<>|{}",
  "1d118a9bad": "機構名稱最少4字，請輸入4~100字機構名稱",
  "441b45b1f5": "企業名最少4字，請輸入4~100字企業名",
  "97457cb1f0": "機構名稱已超過100字，請輸入4~100字機構名稱",
  "8ce00d3b92": "企業名已超過100字，請輸入4~100字企業名",
  "a72778d3de": "姓名最少2字，請輸入2~10字姓名",
  "79c17db5de": "姓名已超過10字，請輸入2~10字姓名",
  "482a118202": "姓名僅支持漢字、數字、英文、·",
  "9a9be18941": "請勾選",
  "e6b7c4aa66": "在線服務協議",
  "595023d905": "創建機構",
  "ba8c2df551": "創建企業",
  "d284384975": "在線服務協議",
  "5c266d5a84": "隱私協議",
  "fcb92dbcf6": "雲辦公服務協議",
  "2ae7a8a3f7": "感謝您選擇WPS 365雲辦公服務。以下主要是介紹您及/或您所代表的組織與金山辦公達成的有關註冊、訂閱、使用本服務的法律協議。",
  "d30a6983bd": "請你閱讀{0} | {1} | {2}，點擊“同意”，即視為同意該協議內容，並接受我們的服務。",
  "263e306ede": "我已閱讀並同意{0} | {1} | {2}",
  "440129c0f1": "請輸入{0}",
  "8ab916983d": "企業名稱",
  "b01d68543b": "您的姓名",
  "684b30d4e9": "您的手機號",
  "a48427e8e2": "用於建立屬於您企業的工作平台",
  "3a81b0f1fc": "方便同事在系統中找到您，進行協作辦公",
  "52bc539b6e": "確認創建",
  "b2fe245e19": "創建企業/團隊: 文件共享與協作",
  "893282d3f7": "請補充企業信息：",
  "cc997bf6aa": "確認",
  "50fdde51ac": "{0}，{1}~{2}位",
  "a19cc5ec18": "{0}，不能包含特殊符號\\u005C/:*?\"<>|{}",
  "26857f28f9": "{0}，僅限輸入漢字、字母、數字",
  "f4080b1431": "{0}，最長{1}位",
  "88e59b2d58": "{0}，11位數字",
  "91d6d4e105": "請輸入驗證碼",
  "bec71bde96": "驗證碼不正確",
  "e20ff8ee19": "{0}必填",
  "8dc09d10d7": "找不到dwId",
  "a03766ce6c": "學校",
  "03542addfe": "企業",
  "adb8a815d1": "手機號碼綁定{0}已達上限",
  "97a6b66f1d": "當前手機號碼已綁定{0}",
  "665e465487": "無法創建{0}，當前手機號碼 “<strong>{1}</strong>” 綁定{0}數量已達上限（最多可綁定5個{2}），你可以進入下方已綁定{3}：",
  "a85b1367ca": "當前手機號碼 “{0}” 已綁定{1}，你可以選擇已有{2}登錄或創建新{3}：",
  "bf992ce17b": "使用其他手機號碼創建{0}",
  "395ea04444": "創建新{0}",
  "4ce3bb86b3": "加入{0}數量超限",
  "df88c4b7a5": "當前手機號碼 “{0}” 綁定{1}數量已達上限",
  "78f7dd59ca": "當前手機號碼 “{0}” 綁定如下{1}，可直接切換使用",
  "8db491a3f8": "繼續創建新{0}",
  "83f6d9e1e4": "再來一次",
  "1dc5f11612": "或",
  "217d76f53e": "反饋問題",
  "b69a6ea62a": "請按住滑鼠左鍵，刮出兩面盾牌",
  "3a31f64800": "恭喜您成功刮出盾牌<br/>繼續下一步操作吧",
  "6a81fcee96": "加載中",
  "e97877a65d": "呀，盾牌不見了<br/>請",
  "8d85456145": "我等得太久啦<br/>請",
  "77ad847b95": "網絡實在不給力<br/>請",
  "dbd1ae3a34": "您刮得太快啦<br/>請",
  "bd8e05cd53": "點擊按鈕開始智能驗證",
  "63d2a8a722": "驗證成功",
  "73141928ad": "驗證失敗，請點擊按鈕刷新",
  "04856c5c8a": "智能檢測中",
  "52cd9bd26d": "您的操作未授權",
  "fd157e8ea8": "創建引導",
  "c6225c5b2b": "歡迎使用企業版",
  "e33423fb1e": "創建成功",
  "7b0c035999": "金山文檔企業創建成功頁",
  "85db8faae0": "企業版使用說明",
  "20591b9b44": "找回企業名稱",
  "b023d76dc2": "成員上傳引導",
  "e2f454e095": "{0}的企業",
  "df466f942b": "分部",
  "26a7b797c4": "分中心",
  "5fc82b360b": "一站式辦公服務平台，讓你辦公更高效",
  "f2e736d52e": "歡迎使用企業版",
  "becc41a35b": "企業名稱",
  "74685cdc58": "請輸入企業或者組織名稱，4~100字",
  "07b55b1907": "企業規模",
  "77b2f763ad": "請選擇您企業的規模",
  "49d2509109": "5人以下",
  "8db2c9b74a": "6-20人",
  "a9fb0cf14a": "21-50人",
  "0fed41f8d3": "51-100人",
  "fb33f25a04": "101-200人",
  "3e3ff0f52e": "201-500人",
  "cd8b51f634": "501-2000人",
  "0662fa6eec": "2000人以上",
  "69334dba1a": "企業需求",
  "79994e749c": "（我們將為企業推薦最佳行業實踐解決方案）",
  "840a017f38": "請選擇最想解決的問題",
  "f045b05c73": "請輸入您創建企業的需求",
  "d8efb0b36d": "其他",
  "adcb8fbb0c": "常用手機號",
  "eb1c73e2ca": "請輸入你常用11位手機號",
  "7f276e7dfa": "免費建立",
  "c391b3eec1": "發送短信失敗",
  "54f4cb8fa7": "短信已發送",
  "231eb1fa1e": "企業用戶_{0}",
  "272b0f9d32": "企業用戶",
  "b209a67331": "創建企業失敗，請刷新頁面。",
  "acb08d0cc9": "創建企業第三步",
  "83db361f51": "創建完成後，觸發跳轉邏輯",
  "1e930326e3": "handleStep進入下一步",
  "184df5c725": "saveForm失敗",
  "736eab3023": "提交校驗",
  "2db62dc13c": "校驗失敗",
  "54fb0afaea": "校驗成功",
  "d39cff3fcf": "跳過極端保存才發現需要驗證碼情況",
  "305b777ae5": "檢查名稱失敗開啟\"企業名稱被佔用\"彈窗及存儲名稱",
  "e57b6686b2": "檢查認證主體是否已被認證，開啟認證保護提示彈窗&存儲對應認證主題信息",
  "f7c86f496d": "創建名重複 || 驗證碼過期 如果存在不通過，則阻止執行",
  "cb37db4fd4": "handleSubmit 失敗",
  "243a569fc4": "該名稱已被註冊，請使用其他名稱",
  "196851a3d9": "企業用戶_{0}",
  "0c3a3595ff": "企業用戶",
  "a33b41e0f2": "創建企業失敗，請刷新頁面。",
  "fcce6a7156": "創建成功",
  "5ec6da58a6": "通知客戶端",
  "259c9dfa4e": "專業版邏輯",
  "864156930f": "vba邏輯",
  "7824efd172": "金山文檔移動端",
  "52b6cfaaaf": "wps客戶端",
  "c7c51beea9": "教育版",
  "8d054d4986": "默認端",
  "b597e18fb1": "isWps365PcClient並且有openurl",
  "b0c13de2a0": "isWps365PcClient或者非client，有openurl",
  "7d0f2ce18c": "isWps365PcClient或者非client，有openurl成功回調",
  "e2c5a07df6": "非client非openurl",
  "29e0414d1f": "非client非openurl回調",
  "60861f7d2a": "autoChange交給業務方自己切換",
  "7c83140d90": "遊客狀態創建，不需要走sdk切換賬號(sdk不支持遊客)，code已接口切換成功了",
  "3379b09e59": "有openurl並且使用href切換",
  "586ff04c22": "單獨跳轉",
  "b6c91f218b": "useSuccessSkip失敗",
  "47d2f3ba66": "其他",
  "57551f86ce": "根據utm_source觸發跳轉不同的方法",
  "64fe3758e2": "您的操作未授權",
  "4da3e1262f": "創建成功，開啟企業辦公之旅",
  "c38dfb8c6c": "創建您第一個團隊",
  "38dddb483b": "進入企業",
  "614d9c91eb": "邀請成員加入",
  "97f1eca0aa": "進入企業",
  "13a4939e90": "加入企業邀請",
  "a319e4ae0a": "邀請同事加入",
  "12e4da6bba": "立即邀請同事",
  "bd885380f6": "獲取邀請鏈接失敗",
  "5e626c4063": "短信已發送",
  "3dc09e7cfd": "您申請找回的企業名數量已達到上限",
  "48318f41f9": "邀請成員加入",
  "45441baac4": "邀請你加入{0}一起協作",
  "e5847fbd67": "複製鏈接，邀請成員",
  "23101dd40a": "正在為您定制解決方案",
  "71bb7e54a8": "項目管理",
  "aff37c79cc": "體驗所選方案",
  "a97b174258": "再邀請<color: red>2</>名同事加入，免費獲得以下企業權益",
  "253855849f": "分享邀請鏈接至工作群邀請同事",
  "57b0a2a63f": "複製鏈接，邀請同事",
  "71c0a37ee1": "進入企業",
  "f848c60e0e": "再邀請<color:red>2</>名同事加入，免費獲得以下企業權益",
  "664e32b4fe": "邀請頁 進入企業",
  "872f14403a": "邀請同事加入",
  "1880e7deb9": "立即邀請同事",
  "cc2a9aaf82": "創建成功",
  "02a13e2583": "再邀請<color: red>2</>名同事加入，免費獲得以下企業權益",
  "5d3593cdce": "獲取團隊信息失敗",
  "c025113ea1": "獲取邀請鏈接失敗",
  "b83bc1e485": "鏈接邀請",
  "0996ced9f6": "對不起，您當前的瀏覽器不支持下載該二維碼",
  "1e88451e31": "已複製邀請鏈接",
  "bb969cabcd": "複製失敗，請重試",
  "15e1f79c7a": "申請加入企業",
  "59c22b4ef8": "收到一個邀請鏈接",
  "0f0b392e60": "創建您的第一個團隊",
  "0437d07c43": "企業名稱",
  "41800c7bf1": "請輸入創建人姓名",
  "1ec5999511": "創建人姓名最長為8位",
  "02da35b4e4": "創建人姓名僅限輸入漢字、字母、數字",
  "184e9f6616": "請輸入聯繫電話",
  "9b587898ba": "請輸入正確格式的聯繫電話",
  "e68c164a02": "請輸入您的郵箱",
  "0b1de22df7": "請輸入正確格式的郵箱",
  "61026181ab": "營業執照必填",
  "c3847e604e": "文件大小超過10M，請重新選擇",
  "49450f4ec7": "重名申訴表必填",
  "39c3b8fa1d": "提交失敗",
  "3ea44d7963": "上傳成功",
  "5b1aa3c2c4": "上傳失敗",
  "7e7f81eaa3": "上傳失敗，文件大於10m",
  "2ff1913de1": "上傳失敗，文件必須是.jpg, .jpeg, .png, .bmp, .pdf",
  "7951a879f2": "營業執照必填",
  "66bda65057": "文件大小超過10M，請重新選擇",
  "8f2305a83d": "重名申訴表必填",
  "55ff0c8c6e": "提交失敗",
  "8dad6d950d": "獲取邀請信息失敗",
  "a5f0ac3a9a": "創建成功",
  "4f1d069770": "邀請頁訪問的utm參數為{0} 和name {1}",
  "f9578cfe6d": "兩步引導訪問的utm參數為{0} 和name {1}",
  "e10d028405": "兩步引導 pcoffice created",
  "8e22e4fcc4": "已複製邀請鏈接",
  "3f327f9f37": "複製失敗，請重試",
  "bd1aecb265": "取消",
  "b6abf9b19a": "同意",
  "e910d9cc0f": "取消",
  "37ab25522d": "同意",
  "196b3eb9cf": "掃碼加入",
  "2b81c52e20": "下載圖片",
  "62152fd9f3": "鏈接邀請",
  "e0a3725651": "對不起，您當前的瀏覽器不支持下載該二維碼",
  "8b7883b2c7": "掃碼加入",
  "9e9a659ed5": "下載圖片",
  "0d55065a9a": "連結邀請",
  "487cf6a106": "對不起，您當前的瀏覽器不支持下載該二維碼",
  "78fd005d1f": "請輸入手機號碼",
  "f909563857": "使用此號碼創建",
  "a26a19f139": "取消創建",
  "cc004ac9ee": "手機號碼",
  "4df8c3c588": "輸入其他手機號碼創建學校",
  "3151cabb3d": "輸入其他手機號碼創建企業",
  "56098a71eb": "點擊智能驗證，發送驗證碼",
  "e96ec218e4": "請輸入短信驗證碼",
  "ce619a0225": "短信驗證碼發送至",
  "0e9863aaeb": "驗證碼有誤，請重新輸入",
  "32dc8629e1": "秒後重新發送",
  "e4eda9add5": "重新發送",
  "b007977564": "獲取審批信息失敗",
  "d8852ffc9c": "非管理員訪問",
  "8a733a2574": "移動端訪問",
  "9e8c152c4f": "PC端訪問",
  "2265a55e93": "同意服務協議",
  "80dabe5aa3": "創建引導",
  "7deee8bf5a": "兩步引導 docsWeb created",
  "69eb501ecb": "您的申訴已失效，無法訪問",
  "aa1d9d98ad": "權限不足，無法訪問",
  "fdf2fe129e": "創建機構",
  "7f0ca0df6b": "創建企業",
  "cc6ac2a93c": "兩步引導 Base mounted",
  "5d6c570bf0": "兩步引導 beforeunload",
  "a4eb8a192d": "大家都在創建的團隊",
  "4912e16a9d": "企業名稱已找回",
  "41c4e87ef2": "您可以點擊鏈接",
  "5e630930c0": "重新創建企業",
  "436a563524": "若您已經創建了企業，您可以參照",
  "0b6e7cbe7f": "《如何修改企業名稱》",
  "cb7bce0775": "教程修改企業名稱",
  "3feadd3040": "當前版本過低，無法使用企業",
  "3cf23de936": "您的軟件版本過低，企業功能無法使用。請前往應用市場更新軟件版本！",
  "a1c5d5d202": "知道了",
  "e50183bd00": "WPS雲文檔",
  "e5031ab679": "安全、同步、協作",
  "c870026dfc": "微信登錄",
  "e7647cd875": "手機或郵箱",
  "07b380074b": "QQ登錄",
  "67921724dd": "其他方式",
  "254da8a9f5": "加入/創建企業數量已達上限",
  "3648e4811b": "進入金山文檔",
  "dcd102b346": "創建自定義團隊",
  "8b9b258cbf": "在此輸入團隊名",
  "19bb6e0ded": "WPS會員享有",
  "2d9fe8d938": "項辦公特權，幫您解決日常辦公中的文檔難題，快來體驗吧！",
  "e8c1caa649": "從本地上傳",
  "03641083a3": "從“個人文檔”移入",
  "eecd3ab9b5": "下次再說",
  "13b447b3a8": "換一批",
  "3c2fc507fc": "當前版本過低，無法使用企業",
  "c3615d8134": "您的軟件版本過低，企業功能無法使用。請前往官網更新軟件版本！",
  "644a36e05b": "去更新",
  "d435105f21": "加入/創建企業數量已達上限",
  "73a286ceb0": "進入金山文檔",
  "c2cec645c0": "取消",
  "b5f5b83c0f": "同意",
  "76ec352da5": "掃碼邀請同事",
  "6a509e4487": "下載二維碼",
  "940cc4a546": "無法創建企業",
  "78b2a62ea5": "進入已有企業或創建新企業",
  "3a6da7f6f9": "當前手機號碼綁定企業數量已達上限 (最多可綁定5個企業)",
  "93bab52870": "當前手機號已綁定企業，你可以選擇已有企業登錄：",
  "ce6e0adaf2": "你可以選擇進入下方已綁定企業:",
  "1ce200a92b": "選擇",
  "bb91ef2999": "創建新企業",
  "024e4a91e5": "企業名稱已被註冊使用",
  "eb089a23a0": "該企業名稱已被註冊使用：",
  "7646558701": "管理員：",
  "1d9c02bd33": "註冊時間：",
  "919fc7805f": "建議您嘗試尋找、聯繫上述您的同事。",
  "0ca71a9344": "您也可以暫時使用其他名稱創建企業（以後可改），再提交申訴。",
  "e83a244e90": "點擊了解如何申訴。",
  "d22bedfb21": "確定",
  "907b78b6e5": "輸入工作小組或團隊名稱",
  "7195b0ac1e": "您可能想創建的團隊",
  "60ed4f915e": "下一步",
  "f5ba8dfb7b": "跳過引導",
  "5c44a3ef68": "最長100個字符",
  "130c53fb20": "名字不能包含非法字符和特殊符號/\\;:*?\"<>|%&",
  "e832d41acc": "兩步引導 跳過",
  "80d9cf7177": "兩步引導 刷新",
  "0aebf80435": "兩步引導 點擊label",
  "e74f515977": "兩步引導 handleSubmit",
  "308d2a53c9": "兩步引導 createGroup",
  "dda2ed7e18": "兩步引導 創建團隊失敗",
  "ded3c35500": "創建團隊失敗",
  "4f18031bc1": "兩步引導 createTemplate",
  "091e5cefcc": "兩步引導 createTemplate error",
  "58cf4e00f0": "驗證碼",
  "92abbf0385": "發送驗證碼",
  "f0f9976ef9": "請輸入手機號",
  "a4ce99b1df": "驗證碼",
  "39d36e0f9f": "確認",
  "0fd8a01938": "發送",
  "9048a4e842": "手機號",
  "9afa1091eb": "重發",
  "58d787001f": "輸入其他手機號創建學校",
  "450905a265": "輸入其他手機號創建企業",
  "f7386de3c6": "下拉選擇",
  "27aa05a92c": "同意服務協議",
  "80af61cb57": "返回上一頁",
  "50149b8d4f": "申請人姓名",
  "e6756f8749": "請輸入您的姓名",
  "3cbd51a2b1": "姓名最少2字，請輸入2~10字姓名",
  "4f79b4813f": "姓名僅支持漢字、數字、英文、·",
  "71d3e75983": "常用手機號",
  "afe5149035": "請輸入您常用手機號碼",
  "1e9270b50f": "請輸入您常用手機號碼，11位數字",
  "ff5dc98dfb": "跳過",
  "165be2ab43": "返回上一步",
  "231d8a335a": "同意服務協議",
  "1cad008ffc": "企業名{0}已被註冊，請使用其他名稱",
  "c6e274fcab": "協議確認",
  "b9352504bb": "關閉協議彈窗",
  "8409e99ad0": "開啟協議彈窗",
  "1593c6dd95": "提交",
  "4f44a9de22": "打開短信驗證",
  "26b70c68b8": "直接進入企業",
  "a8bebcb302": "返回上一頁",
  "c800b4fec5": "邀請頁面 Base Mounted",
  "38b396d5b0": "邀請頁面 docsWeb Mounted",
  "2eb7f9a9f1": "您的申訴已成功提交",
  "2c6f3590fb": "我們預計會在3個工作日內將處理結果發送到您的郵箱",
  "2ea3eff708": ",請留意查收。",
  "53acfba22c": "立即邀請同事",
  "4e6d282f4f": "加入企業邀請",
  "5f72f4b936": "立即邀請同事",
  "e5383077ba": "找回企業名稱",
  "06e3fa2350": "經查詢,",
  "653a263b5e": "的創建者為",
  "769f57269f": "創建者手機號為",
  "09a224695e": "請確認此企業創建者是否為您的同事",
  "3beda6c149": "·若是您的同事，您可以聯繫他",
  "5c74dd10d1": "修改企業名稱或轉讓超級管理員。",
  "da504edb0f": "·若不是您的同事，您可以點擊下方按鈕繼續找回企業名稱。",
  "39194faaf1": "繼續找回企業名稱",
  "e22b829e90": "複製成功",
  "6e1b44752a": "TXT值",
  "79881b1d7a": "立即邀請同事",
  "a5344a45f9": "點擊右上角，選擇【發送給朋友】",
  "a4954a5b08": "立即邀請同事",
  "8e3a1625fb": "找回企業名稱",
  "bf8b8c7005": "上傳企業營業執照",
  "bfd44a66c9": "點擊選擇",
  "d503f20925": "請上傳企業營業執照掃描件或照片",
  "cbebe043c5": "支持 JPG、JPEG、PNG、BMP、PDF 格式，大小不超過 10 MB。",
  "9650b96d7d": "上傳重名申訴信息表",
  "c3b8ae46d3": "請上傳重名申訴信息表掃描件或照片",
  "9e325a9e09": "下載信息表模板",
  "a4711aae88": "提交申請",
  "3a5cc1441e": "認證中...",
  "0bd7bf8511": "我們目前無法驗證您的域名，您可能需要再等候一段時間，以便域名托管服務商更新您的信息。如果一段時間過後仍沒有反應，請嘗試再次驗證，或者更換域名。",
  "fae48d554b": "正在檢查域名",
  "5e1779a0ca": "的驗證記錄，您可以關閉本頁面，稍後再回來查看。",
  "ca85f8b836": "歡迎使用企業版",
  "2570e0f00b": "登錄失敗",
  "40d16a007e": "已自動綁定你的個人帳號",
  "81376b92e4": "{0}的登錄方式，請重新登錄切換企業帳號。",
  "ba679ba739": "知道了，去登錄",
  "c05f64c6c6": "{0}後自動前往登錄",
  "c329ccef3a": "登錄失敗",
  "e370f9afb1": "已自動綁定你的個人帳號",
  "410cf42585": "的登錄方式，請重新登錄切換企業賬號。",
  "062d48aece": "知道了，去登錄",
  "95a105d412": "後自動前往登錄",
  "2d000d5a6d": "發送分享鏈接給成員，成員打開後可申請加入",
  "8861b6e90d": "進入企業",
  "25b9f72fda": "頁面參數錯誤",
  "1c76123efc": "獲取邀請鏈接失敗",
  "6caba48b76": "跳過",
  "f66379c650": "頁面參數錯誤",
  "c45021de2a": "創建失敗",
  "011d470126": "平台持續保護你的信息安全",
  "f1a44d9151": "平台已獲得國際BSI頒布的ISO27001、ISO27701證書，並通過國家三級等保安全資質測評--",
  "255ea5dff7": "安全白皮書",
  "bb55b124f2": "創建企業展示",
  "61e24974a3": "創建企業獲取策略內容",
  "bfdf78febe": "下一步完善資料",
  "c4aa2d2d60": "輸入工作小組或項目名稱",
  "b69765ab64": "大家都在創建的團隊",
  "9657d9408b": "換一批",
  "e21da8c16a": "下一步",
  "224ef5cc9f": "跳過引導",
  "641f58c8f6": "當前企業不支持成員創建團隊，請練習管理員創建",
  "efea622752": "複製鏈接，邀請同事",
  "fd5b40a9fd": "邀請你加入「{0}」，一起協作辦公",
  "b04dd2f10a": "已複製邀請鏈接",
  "d1606a1b1a": "複製失敗，請重試",
  "0d59f3db83": "輸入項目部門或團隊，如“銷售部”",
  "9429513d34": "不需要引導",
  "b54a20b1ff": "創建失敗",
  "093fa0fb74": "登錄授權中...",
  "b383b136f4": "創建企業項目初始化",
  "b6b21b388b": "企業名稱已被註冊使用",
  "285dc68c10": "該企業名稱已被註冊使用：",
  "1bf685b89d": "管理員：",
  "7b4297edcc": "註冊時間：",
  "fa51ea19fc": "建議您嘗試尋找、聯繫上述您的同事。",
  "e3678a996d": "您也可以暫時使用其他名稱創建企業（以後可改），再提交申訴。",
  "5969bc8071": "好的",
  "ba4cf699df": "找回企業名稱",
  "afecee4eb4": "您的姓名",
  "a8bdebc614": "請輸入您的姓名",
  "5bbeb38a66": "聯繫電話",
  "b4f7b44b7a": "請輸入您的聯絡電話",
  "cac2913686": "聯絡電郵",
  "23d3bb3a42": "請輸入您的聯絡電郵",
  "ea106a393c": "上傳企業營業執照",
  "f74131d71e": "點擊選擇",
  "53749c51c5": "請上傳企業營業執照掃描件或照片",
  "c00f2ea171": "支援 JPG、JPEG、PNG、BMP、PDF 格式，大小不超過 10 MB。",
  "57ec07fa97": "上傳重名申訴信息表",
  "8eb0606e94": "請上傳重名申訴信息表掃描件或照片",
  "f59e76c0b0": "下載信息表範本",
  "030bd26fa4": "提交申請",
  "0a602dc727": "資料安全儲存",
  "9138f28acf": "文件共享協作",
  "b3a306cf90": "合規正版化",
  "973c53f725": "建議更改名稱，註冊後可提交機構認證並更新名稱",
  "f886f5e92f": "建議更改名稱，註冊後可提交企業認證並更新名稱",
  "b8051702a3": "該名稱包含敏感詞，請調整名稱或聯絡客服人員",
  "d73881f7d4": "企業名稱受到保護",
  "dc7e58e320": "企業名稱受到保護，使用前需要驗證主體資訊。建議修改企業名稱，或註冊後通過企業認證使用該名稱。",
  "20c3bc070c": "確認",
  "c4278e5f28": "權限不足",
  "9217efae21": "您登錄的帳號暫無權限創建，請聯絡銷售人員處理",
  "52ff08f2ad": "機構名稱受到保護，請調整企業名稱",
  "79386ae280": "請輸入6位驗證碼",
  "d7b2c5a41b": "驗證碼已發送至",
  "ce2e1c26f7": "(10分鐘內有效)",
  "59d338903f": "{0}秒後可重新獲取驗證碼",
  "5aadd14136": "重新獲取驗證碼",
  "90f5c93432": "該名稱已被註冊",
  "1677072f4a": "您可以補充更多資訊，或使用其他名稱註冊",
  "3b8459fb1e": "快速填寫：",
  "6f38edbcb1": "使用該名稱註冊",
  "8406c81e2d": "分店",
  "29d323fa85": "分中心",
  "4f0e806e02": "財務部",
  "3f935efb6b": "同意服務協議",
  "b42241be05": "暫不",
  "99de4b33b7": "同意",
  "7f867e7395": "以其他手機號碼建立企業",
  "0d51a8f7a6": "繼續建立",
  "8bdaecf2e5": "請輸入您的手機號碼",
  "565ae60c8a": "請輸入您的姓名",
  "f76e06d0e7": "請輸入您的手機號碼",
  "7b0fca5255": "請輸入驗證碼",
  "68026d2d25": "歡迎使用企業版",
  "d25b5541be": "免費建立",
  "32cfd73733": "請輸入團隊、企業或組織名稱",
  "4cf83dc4a0": "一分鐘快速建立，與同事高效協作",
  "d320d37116": "免費建立團隊/企業",
  "c54b475dd2": "用戶協議",
  "190d54e616": "{0}的企業",
  "8c1b768ac4": "智能驗證失敗",
  "d74eab0f35": "您的企業名稱填寫信息不符合平台規範，請修改後重試",
  "0f3d62dd4f": "您的姓名填寫信息不符合平台規範，請修改後重試",
  "647cf2211b": "不支持當前手機號碼創建，請更換手機號碼",
  "b63d96cdae": "填寫信息不符合平台規範，請修改後重試",
  "2dbbe8e43f": "不支持當前手機號碼創建，請修改後重試",
  "b18abc5de6": "無綁定手機號碼",
  "f5233dae6f": "請更換手機號碼創建",
  "4167c8b88d": "當前手機號碼可能存在如下情況，請嘗試更換手機號碼創建。如有疑問，請聯繫客戶諮詢。",
  "a8a2433c4d": "微信掃碼添加，聯繫客服諮詢",
  "444a639c09": "我知道了",
  "69a097057f": "當前手機號碼屬於<#BB2726>虛擬運營商號段<#BB2726>",
  "4370b06fd0": "當前手機號碼存在<#BB2726>異常使用行為<#BB2726>",
  "8c49e1dc4a": "需要進行人機驗證",
  "81be771e17": "補充企業資訊，獲取個性化服務",
  "461125b057": "可在團隊中管理文件和資料。團隊成員可便捷查看，還可設置編輯/下載等權限，保障數據安全",
  "c3eb25029b": "所在公司/團隊規模",
  "049f8401ec": "5人以下",
  "c81896349e": "6-20人",
  "7357daac4e": "21-50人",
  "f0e65a0a29": "51-100人",
  "b9fac8204a": "101-200人",
  "62d73dddaf": "201-500人",
  "3bcdaf7160": "501-2000人",
  "ab0b2333fe": "2000人以上",
  "4f756eedc8": "你的角色是",
  "3ba0b502c3": "總經理",
  "702099cc72": "財務",
  "843b603162": "採購",
  "8b414a9b44": "人事/行政",
  "92486b2908": "銷售",
  "ac4e7fb063": "所在組織是否有辦公軟件預算/採購計劃",
  "37634c72dc": "半年內",
  "bd94b6deec": "1年內",
  "713f4aad5c": "正在考慮",
  "c5ea095a4d": "暫無計劃",
  "2409099a69": "創建一個團隊，邀請成員一起協作",
  "9d27dc2d90": "可輸入所在團隊名稱或者最近關注的項目",
  "de19c8509a": "你可能要創建：",
  "1a84699223": "銷售部",
  "efab59502b": "產品部",
  "7e599b3713": "南方運營部",
  "bf494779c2": "採購部",
  "f3a60ab34d": "行政部",
  "bbc50c1ac8": "北方財務部",
  "32629e3dac": "產品財務部",
  "5524d354ba": "資訊科技部",
  "0ccda29a0d": "恭喜完成新手任務，再邀請 3 人可解鎖 90 天高級權益",
  "939eb98492": "已獲得 50 人人数上限、單文件上傳最大 4G 、免費使用 WPS Teams、會議、郵箱等權益。繼續邀請 3 人加入，可解鎖 30 天超值權益",
  "136c26d941": "複製下方鏈接，邀請成員加入",
  "3de5c12558": "複製鏈接，邀請同事",
  "a5d64b14f3": "企業資訊引導",
  "b8f2492701": "企業資訊收集",
  "1f9d053dc0": "創建團隊模板",
  "0e83c79a88": "邀請成員",
  "821fc1906a": "進入企業",
  "463e14ae9c": "請選擇團隊",
  "690f0cdb9e": "完成圖標",
  "c340522a17": "上一步",
  "f9355c72ef": "跳過",
  "bd6c09ebbb": "下一步",
  "2a2603cd3f": "掃碼發送邀請給同事",
  "411e64907a": "複製",
  "b0d988cf23": "下載",
  "e3c0b650ac": "複製成功",
  "713ac624b4": "歡迎使用 WPS 365",
  "b8fff97849": "無效的目標元素",
  "02acdcf296": "html2canvas轉換失敗，未生成canvas",
  "a76988c496": "canvas轉換為blob失敗",
  "af89584edf": "剪貼板api不可用",
  "f90263bbde": "複製圖片失敗",
  "71b05319da": "html轉canvas失敗",
  "38852999fe": "保存信息失敗",
  "4a4c621d07": "創建團隊失敗，請稍後重試",
  "d239a23994": "當前頁面僅限企業帳戶訪問，請先登錄企業帳戶。",
  "d93bfb7fb9": "請輸入內容",
  "42b81a66c4": "長度在 2 到 100 個字符",
  "76d33733db": "不能包含 / \\ ; : * ? \" < > | % & 等特殊字符"
}